export default "__VITE_ASSET__CIbMEIAi__"